module.exports = __webpack_public_path__ + "media/InjectionMolder_OUT.e4b03a17.mp4";